import React from 'react';
import { UpcomingExaminationEvent } from '../../Interfaces/medicalExamination/UpcomingExaminationEvent.interface';
import Text from '../../../../Components/Base/Text/Text';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { joinClasses } from '../../../../Utils/className.util';
import { useEventStatus } from '../../Hooks/MedicalExamination/useMedicalExaminationEvent';
import styles from './DENTMedicalExaminationsAlertEvent.module.scss';

interface Props {
	event: UpcomingExaminationEvent;
	isSelected: boolean;
	onClick: () => void;
}

const DENTMedicalExaminationsAlertEvent = ({
	event,
	isSelected,
	onClick,
}: Props) => {
	const { getEventStatusDisplay } = useEventStatus();

	const statusDisplay = getEventStatusDisplay(event.dateFrom, event.dateTo);

	return (
		<button
			type='button'
			className={joinClasses([
				styles.eventCard,
				isSelected ? styles.selected : '',
			])}
			onClick={onClick}>
			<div className={styles.detailsPanel}>
				{statusDisplay && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.status'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>{statusDisplay}</span>
					</div>
				)}
				{event.patientName && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.patient'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>{event.patientName}</span>
					</div>
				)}
				{event.dateFrom && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.startTime'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>
							<FormattedMomentDate
								date={event.dateFrom}
								format={DateFormat.DATE_TIME}
							/>
						</span>
					</div>
				)}
				{event.dateTo && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.endTime'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>
							<FormattedMomentDate
								date={event.dateTo}
								format={DateFormat.DATE_TIME}
							/>
						</span>
					</div>
				)}
				{event.title && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.procedure'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>{event.title}</span>
					</div>
				)}
				{event.description && (
					<div className={styles.detailRow}>
						<Text
							tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.note'
							className={styles.label}
							inline
						/>
						<span className={styles.value}>{event.description}</span>
					</div>
				)}
			</div>
		</button>
	);
};

export default DENTMedicalExaminationsAlertEvent;
